import { useQuery } from "@tanstack/react-query"
import { getProductVariantById } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductVariantDetails(variantId: string | null | undefined) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["product-variant", variantId],
    queryFn: () => getProductVariantById(variantId!, accessToken ?? undefined),
    enabled: !!variantId,
    staleTime: 0,
  })
}